<span *ngFor="let ansMedia of AnswerMedias" class="answer-opt-image">
  <span>
    <app-media-control [isLoadFile]="ansMedia?.isLoadFile" [mediaName]="ansMedia?.MediaName"
      [mediaUrl]="ansMedia?.MediaURL" [mediaEmbed]=ansMedia?.videoEmbedPath [isAnsMedia]="true">
    </app-media-control>
  </span>
</span>